<swiper-container pagination="true">
  @for (slide of slides(); track $index) {
    <swiper-slide>
      <app-slide [slide]="slide" [large]="large()" />
    </swiper-slide>
  } @empty {
    <swiper-slide>
      <div class="slide-placeholder bg-shimmer"></div>
    </swiper-slide>
  }
</swiper-container>